import { useState } from 'react';

type TabId = 'prehled' | 'ulohy' | 'sluzby' | 'reporty' | 'faktury' | 'spravy';

const navItems: { id: TabId; icon: string; label: string; count?: number }[] = [
  { id: 'prehled', icon: 'ri-dashboard-3-line', label: 'Prehľad', },
  { id: 'ulohy', icon: 'ri-task-line', label: 'Úlohy', count: 2 },
  { id: 'sluzby', icon: 'ri-service-line', label: 'Moje služby' },
  { id: 'reporty', icon: 'ri-bar-chart-2-line', label: 'Reporty' },
  { id: 'faktury', icon: 'ri-bill-line', label: 'Faktúry' },
  { id: 'spravy', icon: 'ri-message-3-line', label: 'Správy', count: 1 },
];

const phases = ['Wireframy', 'Dizajn', 'Vývoj', 'Testovanie', 'Spustenie'];

const allTasks = [
  { label: 'Schváliť finálny dizajn', status: 'waiting', date: 'Dnes', who: 'Vy', priority: 'high' },
  { label: 'Dodať produktové fotografie', status: 'waiting', date: '25.3.', who: 'Vy', priority: 'high' },
  { label: 'Kontrola a korekcia textov', status: 'done', date: '20.3.', who: 'Marek S.', priority: 'low' },
  { label: 'Poslať logo vo formáte SVG', status: 'done', date: '18.3.', who: 'Vy', priority: 'low' },
  { label: 'Odsúhlasiť obsah hlavičky', status: 'done', date: '15.3.', who: 'Vy', priority: 'low' },
];

const services = [
  { label: 'SEO optimalizácia', price: '149 €', cycle: 'mesačne', since: '1.1.2025', next: '1.4.2025', active: true },
  { label: 'Google Ads správa', price: '199 €', cycle: 'mesačne', since: '1.1.2025', next: '1.4.2025', active: true },
  { label: 'Social media management', price: '299 €', cycle: 'mesačne', since: '15.1.2025', next: '15.4.2025', active: true },
  { label: 'Redesign e-shopu', price: '1 490 €', cycle: 'jednorazovo', since: '1.3.2025', next: '-', active: true },
];

const reports = [
  { month: 'Február 2025', visits: '4 821', conversions: '47', cpc: '0.34 €', change: '+18 %', up: true },
  { month: 'Január 2025', visits: '4 108', conversions: '43', cpc: '0.37 €', change: '+11 %', up: true },
  { month: 'December 2024', visits: '3 710', conversions: '39', cpc: '0.41 €', change: '+5 %', up: true },
  { month: 'November 2024', visits: '3 522', conversions: '37', cpc: '0.42 €', change: '+3 %', up: true },
];

const invoices = [
  { num: 'BOO-2025-012', date: '1.3.2025', amount: '647 €', paid: true },
  { num: 'BOO-2025-008', date: '1.2.2025', amount: '647 €', paid: true },
  { num: 'BOO-2025-004', date: '1.1.2025', amount: '647 €', paid: true },
  { num: 'BOO-2024-048', date: '15.12.2024', amount: '1 490 €', paid: false },
];

const messages = [
  { from: 'Boostio', text: 'Ahoj Ján! Dizajn prvej stránky je hotový, prosím pozri si ho v sekcii Prehľad.', time: 'včera 14:22', mine: false },
  { from: 'Vy', text: 'Super, pozriem to dnes večer a dám vedieť.', time: 'včera 15:04', mine: true },
  { from: 'Boostio', text: 'Perfekt, ak bude čokoľvek na zmenu, stačí napísať sem alebo pridať komentár priamo do úlohy.', time: 'včera 15:10', mine: false },
  { from: 'Vy', text: 'Dizajn vyzerá skvele! Len by som zmenil farbu CTA tlačidla na viac oranžovú.', time: 'dnes 9:47', mine: true },
  { from: 'Boostio', text: 'Jasné, zapracujeme dnes. Uvidíš to v portáli hneď po aktualizácii.', time: 'dnes 10:02', mine: false },
];

function TabPrehled() {
  return (
    <div className="p-4 space-y-3 overflow-y-auto h-full">
      <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
        <div className="flex items-start justify-between mb-3">
          <div>
            <p className="text-white font-bold text-sm">Redesign e-shopu - Fáza 3</p>
            <div className="flex items-center gap-2 mt-1">
              <span className="bg-amber-500/10 border border-amber-500/20 text-amber-400 text-[10px] px-2 py-0.5 rounded-full font-semibold">V progrese</span>
              <span className="text-zinc-600 text-[10px]">Termín: 15. apríl 2025</span>
            </div>
          </div>
          <span className="text-orange-400 font-black text-2xl">65%</span>
        </div>
        <div className="h-1.5 bg-zinc-800 rounded-full overflow-hidden mb-3">
          <div className="h-full w-[65%] bg-gradient-to-r from-orange-500 to-amber-400 rounded-full" />
        </div>
        <div className="flex gap-3 flex-wrap">
          {phases.map((ph, i) => (
            <div key={ph} className="flex items-center gap-1">
              <div className={`w-3 h-3 rounded-full flex items-center justify-center ${i < 2 ? 'bg-emerald-500' : i === 2 ? 'bg-orange-500 ring-2 ring-orange-500/30' : 'bg-zinc-700'}`}>
                {i < 2 && <i className="ri-check-line text-white" style={{ fontSize: 8 }} />}
                {i === 2 && <div className="w-1 h-1 bg-white rounded-full" />}
              </div>
              <span className={`text-[10px] font-medium ${i < 2 ? 'text-emerald-500' : i === 2 ? 'text-orange-400' : 'text-zinc-600'}`}>{ph}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-white font-bold text-xs">Úlohy</span>
            <span className="text-orange-400 text-[10px] font-semibold">2 čakajú</span>
          </div>
          {allTasks.slice(0, 4).map((t) => (
            <div key={t.label} className="flex items-center gap-2 py-1">
              <div className={`w-3.5 h-3.5 rounded flex-shrink-0 flex items-center justify-center ${t.status === 'done' ? 'bg-emerald-500/15 border border-emerald-500/30' : 'bg-orange-500/15 border border-orange-500/30'}`}>
                <i className={`${t.status === 'done' ? 'ri-check-line text-emerald-400' : 'ri-time-line text-orange-400'}`} style={{ fontSize: 8 }} />
              </div>
              <span className={`text-[11px] flex-1 truncate ${t.status === 'done' ? 'text-zinc-600 line-through' : 'text-zinc-300'}`}>{t.label}</span>
              <span className={`text-[10px] ${t.status === 'waiting' ? 'text-orange-400 font-semibold' : 'text-zinc-700'}`}>{t.date}</span>
            </div>
          ))}
        </div>
        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-white font-bold text-xs">Aktívne služby</span>
            <span className="text-emerald-400 text-[10px] font-semibold">3 mesačné</span>
          </div>
          {services.slice(0, 3).map((s) => (
            <div key={s.label} className="flex items-center justify-between py-1">
              <div className="flex items-center gap-1.5"><span className="w-1.5 h-1.5 bg-emerald-400 rounded-full" /><span className="text-zinc-300 text-[11px]">{s.label}</span></div>
              <span className="text-white text-[11px] font-bold">{s.price}</span>
            </div>
          ))}
          <div className="border-t border-zinc-800 pt-2 mt-1 flex items-center justify-between">
            <span className="text-zinc-500 text-[10px]">Celkom/mes</span>
            <span className="text-orange-400 text-sm font-black">647 €</span>
          </div>
        </div>
      </div>
      <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
        <div className="flex items-center justify-between mb-3">
          <span className="text-white font-bold text-xs">Report - február 2025</span>
          <button className="flex items-center gap-1 text-orange-400 text-[10px] font-semibold cursor-pointer"><i className="ri-download-line" />PDF</button>
        </div>
        <div className="grid grid-cols-4 gap-2">
          {[{ l: 'Návštevy', v: '4 821', c: '+18 %', up: true }, { l: 'Kľúč. slová', v: '312', c: '+24 %', up: true }, { l: 'Konverzie', v: '47', c: '+9 %', up: true }, { l: 'CPC', v: '0.34 €', c: '-12 %', up: false }].map((m) => (
            <div key={m.l} className="text-center">
              <p className="text-white font-black text-base">{m.v}</p>
              <p className="text-zinc-600 text-[9px] mb-1">{m.l}</p>
              <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded-full ${m.up ? 'bg-emerald-500/10 text-emerald-400' : 'bg-orange-500/10 text-orange-400'}`}>{m.c}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function TabUlohy() {
  const [filter, setFilter] = useState<'all' | 'waiting' | 'done'>('all');
  const filtered = filter === 'all' ? allTasks : allTasks.filter((t) => t.status === filter);
  return (
    <div className="p-4 h-full flex flex-col">
      <div className="flex items-center gap-2 mb-4">
        {(['all', 'waiting', 'done'] as const).map((f) => (
          <button key={f} onClick={() => setFilter(f)} className={`px-3 py-1 rounded-full text-[11px] font-semibold cursor-pointer whitespace-nowrap transition-all ${filter === f ? 'bg-orange-500/15 border border-orange-500/30 text-orange-400' : 'bg-zinc-800 border border-zinc-700 text-zinc-500 hover:text-zinc-300'}`}>
            {f === 'all' ? 'Všetky' : f === 'waiting' ? 'Čakajúce' : 'Hotové'}
          </button>
        ))}
        <span className="ml-auto text-zinc-600 text-[10px]">{filtered.length} úloh</span>
      </div>
      <div className="space-y-2 overflow-y-auto flex-1">
        {filtered.map((t) => (
          <div key={t.label} className={`flex items-center gap-3 p-3 rounded-xl border transition-all ${t.status === 'waiting' ? 'bg-zinc-900 border-zinc-800' : 'bg-zinc-900/40 border-zinc-800/50'}`}>
            <div className={`w-5 h-5 rounded flex-shrink-0 flex items-center justify-center ${t.status === 'done' ? 'bg-emerald-500/15 border border-emerald-500/30' : 'bg-orange-500/15 border border-orange-500/30'}`}>
              <i className={`${t.status === 'done' ? 'ri-check-line text-emerald-400' : 'ri-time-line text-orange-400'}`} style={{ fontSize: 10 }} />
            </div>
            <div className="flex-1 min-w-0">
              <p className={`text-xs font-medium ${t.status === 'done' ? 'text-zinc-500 line-through' : 'text-zinc-200'}`}>{t.label}</p>
              <p className="text-[10px] text-zinc-600 mt-0.5">{t.who}</p>
            </div>
            <div className="text-right flex-shrink-0">
              <span className={`text-[10px] font-semibold ${t.status === 'waiting' && t.date === 'Dnes' ? 'text-red-400' : t.status === 'waiting' ? 'text-orange-400' : 'text-zinc-600'}`}>{t.date}</span>
              {t.priority === 'high' && t.status === 'waiting' && (
                <div className="mt-0.5 bg-red-500/10 border border-red-500/20 text-red-400 text-[9px] px-1.5 py-0.5 rounded-full text-center font-semibold">Priorita</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function TabSluzby() {
  return (
    <div className="p-4 overflow-y-auto h-full">
      <div className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden">
        <div className="grid text-[10px] text-zinc-500 font-semibold uppercase tracking-wide px-4 py-2 border-b border-zinc-800" style={{ gridTemplateColumns: '2fr 1fr 1fr 1fr auto' }}>
          <span>Služba</span><span>Cena</span><span>Faktur.</span><span>Ďalšia platba</span><span>Status</span>
        </div>
        {services.map((s) => (
          <div key={s.label} className="grid items-center px-4 py-3 border-b border-zinc-800/50 last:border-0" style={{ gridTemplateColumns: '2fr 1fr 1fr 1fr auto' }}>
            <div>
              <p className="text-zinc-200 text-xs font-semibold">{s.label}</p>
              <p className="text-zinc-600 text-[10px]">od {s.since}</p>
            </div>
            <span className="text-white text-xs font-bold">{s.price}</span>
            <span className="text-zinc-400 text-[11px]">{s.cycle}</span>
            <span className="text-zinc-400 text-[11px]">{s.next}</span>
            <span className="bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-[9px] px-2 py-0.5 rounded-full font-semibold whitespace-nowrap">Aktívna</span>
          </div>
        ))}
      </div>
      <div className="mt-4 bg-orange-500/5 border border-orange-500/15 rounded-xl px-4 py-3 flex items-center justify-between">
        <div>
          <p className="text-zinc-400 text-xs">Mesačné náklady (opakujúce sa)</p>
          <p className="text-white font-black text-xl mt-0.5">647 €<span className="text-zinc-500 text-sm font-medium">/mes</span></p>
        </div>
        <div className="text-right">
          <p className="text-zinc-600 text-[10px]">Ďalšia fakturácia</p>
          <p className="text-orange-400 text-xs font-bold mt-0.5">1. apríl 2025</p>
        </div>
      </div>
    </div>
  );
}

function TabReporty() {
  return (
    <div className="p-4 space-y-3 overflow-y-auto h-full">
      <p className="text-zinc-500 text-[11px]">Mesačné reporty za vaše aktívne kampane a projekty.</p>
      {reports.map((r) => (
        <div key={r.month} className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 flex items-center justify-center bg-orange-500/10 border border-orange-500/20 rounded-lg">
                <i className="ri-file-chart-line text-orange-400 text-xs" />
              </div>
              <div>
                <p className="text-white font-bold text-xs">{r.month}</p>
                <div className="flex items-center gap-1 mt-0.5">
                  <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded-full ${r.up ? 'bg-emerald-500/10 text-emerald-400' : 'bg-red-500/10 text-red-400'}`}>{r.change}</span>
                  <span className="text-zinc-600 text-[9px]">oproti minulému mesiacu</span>
                </div>
              </div>
            </div>
            <button className="flex items-center gap-1 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 text-zinc-300 text-[10px] font-semibold px-3 py-1.5 rounded-lg cursor-pointer transition-all whitespace-nowrap">
              <i className="ri-download-2-line text-orange-400" />
              PDF
            </button>
          </div>
          <div className="grid grid-cols-3 gap-3">
            {[{ l: 'Návštevy', v: r.visits }, { l: 'Konverzie', v: r.conversions }, { l: 'Avg. CPC', v: r.cpc }].map((m) => (
              <div key={m.l} className="bg-zinc-950/60 rounded-lg px-3 py-2 text-center">
                <p className="text-white font-bold text-sm">{m.v}</p>
                <p className="text-zinc-600 text-[9px]">{m.l}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function TabFaktury() {
  return (
    <div className="p-4 overflow-y-auto h-full">
      <div className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden">
        <div className="grid text-[10px] text-zinc-500 font-semibold uppercase tracking-wide px-4 py-2 border-b border-zinc-800" style={{ gridTemplateColumns: '1.5fr 1fr 1fr 1fr auto' }}>
          <span>Číslo</span><span>Dátum</span><span>Suma</span><span>Status</span><span />
        </div>
        {invoices.map((inv) => (
          <div key={inv.num} className="grid items-center px-4 py-3 border-b border-zinc-800/50 last:border-0" style={{ gridTemplateColumns: '1.5fr 1fr 1fr 1fr auto' }}>
            <span className="text-zinc-300 text-[11px] font-mono">{inv.num}</span>
            <span className="text-zinc-400 text-[11px]">{inv.date}</span>
            <span className="text-white text-xs font-bold">{inv.amount}</span>
            <span className={`text-[9px] font-semibold px-2 py-0.5 rounded-full w-fit ${inv.paid ? 'bg-emerald-500/10 border border-emerald-500/20 text-emerald-400' : 'bg-amber-500/10 border border-amber-500/20 text-amber-400'}`}>
              {inv.paid ? 'Uhradená' : 'Čaká na platbu'}
            </span>
            <button className="w-6 h-6 flex items-center justify-center text-zinc-600 hover:text-orange-400 cursor-pointer transition-colors">
              <i className="ri-download-line text-xs" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

function TabSpravy() {
  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 p-4 space-y-3 overflow-y-auto">
        {messages.map((msg, i) => (
          <div key={i} className={`flex items-end gap-2 ${msg.mine ? 'flex-row-reverse' : ''}`}>
            {!msg.mine && (
              <div className="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mb-1">
                <i className="ri-rocket-2-fill text-white" style={{ fontSize: 9 }} />
              </div>
            )}
            <div className={`max-w-[75%] ${msg.mine ? 'items-end' : 'items-start'} flex flex-col`}>
              <div className={`px-3 py-2 rounded-2xl text-[11px] leading-relaxed ${msg.mine ? 'bg-orange-500 text-white rounded-br-sm' : 'bg-zinc-800 text-zinc-200 rounded-bl-sm'}`}>
                {msg.text}
              </div>
              <span className="text-[9px] text-zinc-600 mt-1 px-1">{msg.time}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="border-t border-zinc-800 p-3 flex items-center gap-2">
        <div className="flex-1 bg-zinc-800 border border-zinc-700 rounded-xl px-3 py-2 text-[11px] text-zinc-600 cursor-not-allowed">
          Napíšte správu...
        </div>
        <div className="w-8 h-8 flex items-center justify-center bg-orange-500/20 border border-orange-500/30 rounded-xl">
          <i className="ri-send-plane-line text-orange-400 text-xs" />
        </div>
      </div>
    </div>
  );
}

const tabContent: Record<TabId, JSX.Element> = {
  prehled: <TabPrehled />,
  ulohy: <TabUlohy />,
  sluzby: <TabSluzby />,
  reporty: <TabReporty />,
  faktury: <TabFaktury />,
  spravy: <TabSpravy />,
};

export default function KPDashboardMock() {
  const [activeTab, setActiveTab] = useState<TabId>('prehled');

  const headerLabels: Record<TabId, { title: string; sub: string }> = {
    prehled: { title: 'Dobré ráno, Ján!', sub: 'Aktualizované pred 5 minútami' },
    ulohy: { title: 'Vaše úlohy', sub: '2 úlohy čakajú na vás' },
    sluzby: { title: 'Moje služby', sub: 'Prehľad aktívnych objednávok' },
    reporty: { title: 'Mesačné reporty', sub: '4 reporty k dispozícii' },
    faktury: { title: 'Faktúry', sub: '1 faktúra čaká na platbu' },
    spravy: { title: 'Správy', sub: '1 nová správa od Boostio' },
  };

  return (
    <section id="ukazka" className="py-24 bg-zinc-950 relative">
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse at 50% 50%, rgba(249,115,22,0.04) 0%, transparent 70%)' }} />
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-zinc-900 border border-zinc-700 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-computer-line text-orange-400 text-sm" />
            <span className="text-zinc-300 text-sm font-semibold">Ukážka portálu - vyskúšajte klikanie</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-3">Takto vyzerá váš portál</h2>
          <p className="text-zinc-500 text-base max-w-lg mx-auto">Kliknite na položky v ľavom menu a pozrite sa, čo všetko nájdete vo svojom portáli.</p>
        </div>

        {/* Browser frame */}
        <div className="rounded-2xl overflow-hidden border border-zinc-700/60 bg-zinc-900">
          {/* Browser bar */}
          <div className="bg-zinc-800 px-5 py-3 flex items-center gap-3 border-b border-zinc-700/60">
            <div className="flex gap-1.5">
              <div className="w-3 h-3 rounded-full bg-red-500/50" />
              <div className="w-3 h-3 rounded-full bg-yellow-500/50" />
              <div className="w-3 h-3 rounded-full bg-emerald-500/50" />
            </div>
            <div className="flex-1 mx-3 bg-zinc-700/50 rounded-md px-3 py-1.5 flex items-center gap-2">
              <i className="ri-lock-line text-zinc-500 text-xs" />
              <span className="text-zinc-500 text-xs font-mono">portal.boostio.sk</span>
            </div>
            <div className="flex gap-2"><i className="ri-refresh-line text-zinc-600 text-sm" /></div>
          </div>

          {/* App shell */}
          <div className="flex" style={{ height: '540px' }}>
            {/* Sidebar */}
            <div className="w-48 flex-shrink-0 bg-zinc-900 border-r border-zinc-800 flex flex-col">
              <div className="px-4 py-3 border-b border-zinc-800 flex items-center gap-2">
                <div className="w-6 h-6 bg-orange-500 rounded-md flex items-center justify-center"><i className="ri-rocket-2-fill text-white text-xs" /></div>
                <span className="text-white font-bold text-sm">boost<span className="text-orange-500">io</span></span>
                <span className="ml-auto text-zinc-600 text-[9px] border border-zinc-700 rounded px-1">portál</span>
              </div>
              <div className="px-4 py-2.5 border-b border-zinc-800">
                <div className="text-[10px] text-zinc-600 mb-0.5">Prihlásený ako</div>
                <div className="text-white text-xs font-semibold">Bratislava Pet Shop</div>
              </div>
              <nav className="flex-1 p-2 space-y-0.5">
                {navItems.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => setActiveTab(item.id)}
                    className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg cursor-pointer text-left transition-all duration-150 whitespace-nowrap ${
                      activeTab === item.id
                        ? 'bg-orange-500/10 border border-orange-500/15'
                        : 'hover:bg-zinc-800/70 border border-transparent'
                    }`}
                  >
                    <i className={`${item.icon} text-sm ${activeTab === item.id ? 'text-orange-400' : 'text-zinc-500'}`} />
                    <span className={`text-xs font-medium flex-1 ${activeTab === item.id ? 'text-orange-300' : 'text-zinc-500'}`}>{item.label}</span>
                    {item.count && (
                      <span className="bg-orange-500 text-white text-[9px] w-4 h-4 rounded-full flex items-center justify-center font-bold">{item.count}</span>
                    )}
                  </button>
                ))}
              </nav>
              <div className="p-2 border-t border-zinc-800">
                <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg cursor-pointer hover:bg-zinc-800/60">
                  <i className="ri-logout-box-line text-zinc-700 text-xs" />
                  <span className="text-zinc-700 text-xs">Odhlásiť sa</span>
                </div>
              </div>
            </div>

            {/* Main content */}
            <div className="flex-1 bg-zinc-950 flex flex-col min-w-0">
              <div className="border-b border-zinc-800 px-5 py-3 flex items-center justify-between flex-shrink-0">
                <div>
                  <p className="text-white font-bold text-sm">{headerLabels[activeTab].title}</p>
                  <p className="text-zinc-600 text-[10px]">{headerLabels[activeTab].sub}</p>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full animate-pulse" />
                    <span className="text-emerald-400 text-[10px] font-medium">Live</span>
                  </div>
                  <div className="w-7 h-7 bg-orange-500/20 border border-orange-500/30 rounded-full flex items-center justify-center">
                    <span className="text-orange-400 text-[10px] font-bold">JN</span>
                  </div>
                </div>
              </div>
              <div className="flex-1 overflow-hidden">
                {tabContent[activeTab]}
              </div>
            </div>
          </div>
        </div>
        <p className="text-center text-zinc-600 text-sm mt-5">Ukážkové dáta · Reálne rozhranie dostanete po objednaní prvej služby</p>
      </div>
    </section>
  );
}
